import { createSlice } from '@reduxjs/toolkit'

import { baseModelState, updateExtraReducers, openForm, closeForm } from 'store/common'
import api from 'models/Building/api'


const initialState = {
  ...baseModelState,
}


export const building = createSlice({
  name: 'building',
  initialState,
  reducers: {
    openForm,
    closeForm,
  },
  extraReducers: (builder) => {
    updateExtraReducers(builder, api.endpoints.updateBuilding);
  },
});

export default building.reducer;

export const BuildingActions = building.actions;
